export default {"src":"/_next/static/media/hedge-on-dark.c20a90d6.svg","height":250,"width":743,"blurWidth":0,"blurHeight":0};